import React, { useState } from 'react';

const fmt = (n) => n.toLocaleString('en-US');

function ROICalculator() {
  const [conv, setConv] = useState(600);
  const [taux, setTaux] = useState(8);
  const [panier, setPanier] = useState(1500);

  const closed = conv * (taux / 100);
  const clients = closed * 0.35;
  const rev = Math.round(clients * panier);
  const lost = Math.round(rev * 0.7);

  return (
    <section id="roi">
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">Calculator</div>
          <h2>How much are you leaving on the table each month?</h2>
          <p>Adjust your numbers. The math updates live. Nothing is stored.</p>
        </div>
        <div className="roi">
          <div className="roi-inputs">
            <div className="roi-field">
              <label>Inbound conversations / month</label>
              <div className="val"><span>{fmt(conv)}</span></div>
              <input type="range" min="100" max="3000" step="50" value={conv}
                onChange={e => setConv(Number(e.target.value))} />
            </div>
            <div className="roi-field">
              <label>Close rate (%)</label>
              <div className="val"><span>{taux}</span>%</div>
              <input type="range" min="2" max="20" step="1" value={taux}
                onChange={e => setTaux(Number(e.target.value))} />
            </div>
            <div className="roi-field">
              <label>Value of a signed client ($)</label>
              <div className="val">$<span>{fmt(panier)}</span></div>
              <input type="range" min="300" max="10000" step="100" value={panier}
                onChange={e => setPanier(Number(e.target.value))} />
            </div>
          </div>
          <div className="roi-out">
            <div className="roi-card lose">
              <div className="t">Revenue lost / month without fast replies &amp; follow-up</div>
              <div className="n">– ${fmt(lost)}</div>
            </div>
            <div className="roi-card win">
              <div className="t">Potential revenue recovered with Salesyo</div>
              <div className="n">+ ${fmt(rev)}</div>
            </div>
          </div>
          <p className="roi-note">Assumption: 35% signature rate on closed conversations. Indicative estimate, to be validated against your actual business.</p>
        </div>
      </div>
    </section>
  );
}

export default ROICalculator;
